import { TabStyles } from '@tableau/widgets';

import { CSSProperties } from 'react';
import { CommonStyles } from '../../common/react/CommonStyles';
import { imgPath } from '../../common/utilities/ImgUrl';
import { cssClass } from '../../style';

const CSS_PREFIX = 'WelcomeScreen';
const COLOR_OFF_WHITE = 'rgba(255, 255, 255, 0.9)';
export namespace WelcomeScreenStyles {

  export const root = cssClass(CSS_PREFIX, 'root', {
    position: 'relative',
    backgroundColor: TabStyles.Colors.ApplicationBlue,
    padding: '26px 36px',
    backgroundImage: `${getBackgroundImageUrl('home_welcome_screen_trend_line.png')} ,${getBackgroundImageUrl('home_welcome_screen_main.png')}`,
    backgroundPosition: 'bottom left, bottom right',
    backgroundSize: 'contain, contain',
    backgroundRepeat: 'repeat-x, no-repeat',
  });

  export const closeButton: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    width: 30,
    height: 30,
    cursor: 'pointer',
  };

  export const closeButtonContainer = cssClass(CSS_PREFIX, 'close_button_container', {
    position: 'absolute',
    top: 5,
    right: 5,
    background: 'none',
    opacity: 0.5,
    lineHeight: 0,  // Default line height added extra height
    $nest: {
      '&:hover': {
        opacity: 1,
      }
    }
  });

  export const header = cssClass(CSS_PREFIX, 'header', {
    fontSize: 28,
    fontWeight: 'normal',
    color: COLOR_OFF_WHITE,
    marginTop: 12,
    marginBottom: 10,
    lineHeight: 1.3,
  });

  export const subheader = cssClass(CSS_PREFIX, 'subheader', {
    fontSize: 14,
    fontWeight: 'normal',
    lineHeight: '21px',
    color: COLOR_OFF_WHITE,
    marginTop: 14,
    marginBottom: 26,
  });

  export const links = cssClass(CSS_PREFIX, 'links', {
    marginTop: 26,
    marginBottom: 0,
    color: TabStyles.Colors.WhiteTransparentLine,
    fontWeight: 'lighter',
  });

  export const link = cssClass(CSS_PREFIX, 'link', {
    color: COLOR_OFF_WHITE,
    fontFamily: CommonStyles.Fonts.HeavyFont,
    fontSize: TabStyles.Typography.Sizing.Default,
    $nest: {
      '&:hover': {
        color: TabStyles.Colors.White,
      }
    }
  });

  export const linkDivider = cssClass(CSS_PREFIX, 'link-divider', {
    padding: '0 5px',
  });
}

export function getBackgroundImageUrl(imageLocation: string) {
  return 'url("' + imgPath(imageLocation) + '")';
}
